import { z } from "zod";

/**
 * Zod schemas for the sender copywriting preference (PREC-3719 §6).
 * Mirrors apps/api/src/sender-copywriting-preference/dto.
 */

export const SenderPhraseSetSchema = z.object({
	openers: z.array(z.string()),
	closings: z.array(z.string()),
	ctas: z.array(z.string()),
});

export const SenderCopywritingPreferenceSchema = z.object({
	primaryLanguage: z.string().nullable(),
	secondaryLanguages: z.array(z.string()),
	fallbackLanguage: z.string().nullable(),
	phrases: z.record(z.string(), SenderPhraseSetSchema),
});

export type SenderPhraseSet = z.infer<typeof SenderPhraseSetSchema>;
export type SenderCopywritingPreference = z.infer<typeof SenderCopywritingPreferenceSchema>;

export const UpsertSenderCopywritingPreferenceSchema = z.object({
	primaryLanguage: z.string().optional(),
	secondaryLanguages: z.array(z.string()).optional(),
	fallbackLanguage: z.string().optional(),
	phrases: z.record(z.string(), SenderPhraseSetSchema.partial()).optional(),
});

export type UpsertSenderCopywritingPreferenceRequest = z.infer<
	typeof UpsertSenderCopywritingPreferenceSchema
>;
